module.exports = __webpack_public_path__ + "img/abc-country.c6a1228a.png";